export async function fitImageForPDF(url: string, maxWidth: number = 1600, maxHeight: number = 1200, options?: { signal?: AbortSignal }): Promise<string> {
  const { signal } = options ?? {};

  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      return reject(new DOMException("Aborted", "AbortError"));
    }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = url;

    const cleanup = () => {
      img.onload = null;
      img.onerror = null;
      if (signal) signal.removeEventListener('abort', onAbort);
    };

    const onAbort = () => {
      cleanup();
      reject(new DOMException('Aborted', 'AbortError'));
    };

    if (signal) {
      signal.addEventListener('abort', onAbort, { once: true });
    }

    img.onload = () => {
      if (signal?.aborted) {
        cleanup();
        return reject(new DOMException('Aborted', 'AbortError'));
      }

      if (img.width <= maxWidth && img.height <= maxHeight) {
        cleanup();
        resolve(url);
        return;
      }

      const scale = Math.min(maxWidth / img.width, maxHeight / img.height);
      const canvas = document.createElement('canvas');
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext('2d')!;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      cleanup();
      resolve(canvas.toDataURL('image/png'));
    };

    img.onerror = (err) => {
      cleanup();
      reject(err);
    };
  });
}